import React, { Component } from 'react';
import Modal from 'react-responsive-modal';
import {number_format,number_input_format} from '../helper/format';
import $ from 'jquery';
import {
  isMobile
} from "react-device-detect";

export default class Welfarepopup extends Component {
    constructor(props)
    {
        super(props);
        this.state = {
            open: false,
            list: [],
            selectedItem: null
        }
    }
    Open(welfare_item)
    {
        this.setState({
            open: true,
            selectedItem: welfare_item
        });
        this.requestData();
    }
    Close()
    {
        this.setState({
            open: false
        });
    }
    Apply(item)
    {
       this.props.onWelfareChanged(item);
       this.Close();
    }
    requestData()
    {
        const self = this;
        $.post('https://api.tfamily.co.kr/api/mobile/base',{},function(data){
            let parsedData = JSON.parse(data), welfare_items, displaylist = [];
            welfare_items = parsedData.data.welfare;

            let emptyItem = {
                name: "미적용",
                discount: 0,
                display_selected_item: false
            }

            if(self.state.selectedItem == null)
            {
                emptyItem.display_selected_item = true;
            }

            displaylist.push(emptyItem);

            for (let i = 0 ; i < welfare_items.length ; i++)
            {
                let items = welfare_items[i];

                if(self.state.selectedItem && self.state.selectedItem.name === items.name)
                {
                    welfare_items[i].display_selected_item = true;
                }
                displaylist.push(welfare_items[i]);
            }

            self.setState({
                list: displaylist
            });
        });
    }
    render()
    {
        const self = this;
        return (
            <Modal open={this.state.open} onClose={()=>{self.Close()}} center>
                <div className="modal-dialog modal-md mb0">
                    <div className={ (isMobile) ? 'popupPadding3' : 'popupPadding pr45'}>
                        <div className="md-popup-header"> &nbsp;복지할인</div>
                        <div className="md-popup-contents pt0 pl0">
                            <table className="table priceTable">
                                <tbody>
                                    {
                                        self.state.list.map((item, index)=>{
                                            let printDiscount = '';
                                            if(item.type==1)
                                            {
                                              /*
                                                printDiscount += '(' + number_input_format(item.discount) + ' 원 할인';
                                                if( item.discount_max&&item.discount_max!=0 )
                                                {
                                                    printDiscount += ', 최대 ' + number_input_format(item.discount_max) +' 원 할인';
                                                }
                                                printDiscount += ')';
                                              */
                                            } else if ( item.type == 2)
                                            {
                                            //    printDiscount += '(' + item.discount + '% 할인)'
                                            }
                                            return(
                                            <tr onClick={()=>{self.Apply(item)}} key={index} className={(item.display_selected_item) ? 'priceSelect' : ''} >
                                                <td>
                                                    {item.name} {printDiscount}
                                                </td>
                                            </tr>
                                           )
                                        })
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </Modal>
        )
    }
}
